import { useState } from 'react';
import { TextField } from '@mui/material';
import ButtonWithSpinner from '../../../components/buttons/ButtonWithSpinner';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './ResetPasswordForm.scss';

const defaultProps = {
  onSubmit: () => { },
  loading: false,
};

const ResetPasswordForm = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { onSubmit, loading } = mergedProps;
  const [value, setValue] = useState('');

  const handleOnTextChange = (e) => {
    setValue(e.target.value);
  };

  const handleOnKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit(value);
    }
  };

  const handleOnNextClick = (e) => {
    e.preventDefault();
    onSubmit(value);
  };

  return (
    <div className='reset-password-form'>
      <div className='content'>
        <TextField
          className='text-form'
          value={value}
          label='New password'
          inputProps={{
            maxLength: 255,
          }}
          type='password'
          onKeyPress={handleOnKeyPress}
          onChange={handleOnTextChange}
        />
      </div>
      <div className='actions'>
        <ButtonWithSpinner
          className='btn-primary'
          label='Reset'
          fullWidth
          disabled={!value || value.length < 4}
          loading={loading}
          onClick={handleOnNextClick}
        />
      </div>
    </div>
  );
};

export default ResetPasswordForm;
